import React from 'react';
const MemberDirectory = () => {
  return (
    <div className="p-6">
      <h1 className="font-serif font-bold text-3xl text-primary mb-6">Member Directory</h1>
      <div className="bg-card p-8 rounded-xl shadow-card">
        <p className="text-muted-foreground">Member directory page</p>
      </div>
    </div>
  );
};
export default MemberDirectory;